/** Base TanStack Query key for the open drift-alerts list. */
export const DRIFT_ALERTS_QUERY_KEY = ["admin", "subscriptions", "drift-alerts"] as const;

/** Page size for the drift-alerts list. The API caps `limit` at 100. */
export const DRIFT_ALERTS_PAGE_SIZE = 25;

/** Matches the API `ResolveDriftAlertDto.note` `@MaxLength(1000)`. */
export const RESOLUTION_NOTE_MAX_LENGTH = 1000;

// ── Admin subscription list + detail (API-PV2-3) ───────────────────

/** `SubscriptionStatus` enum — mirrors the API `SubscriptionStatus`. */
export const SUBSCRIPTION_STATUSES = [
  "ACTIVE",
  "TRIALING",
  "PAST_DUE",
  "PAUSED",
  "INCOMPLETE",
  "PENDING_ACTIVATION",
  "CANCELLED",
] as const;
export type SubscriptionStatus = (typeof SUBSCRIPTION_STATUSES)[number];

/**
 * Subscription tier key. Free-form since the capacity pivot — tiers are now
 * rows in the `subscription_tiers` table (e.g. `TIER_1`), no longer the closed
 * `FIT | FITTER | FITTEST` enum. The display name lives on the tier config; the
 * raw key is what `subscriptions.tier` carries and what the list filter targets.
 */
export type SubscriptionTier = string;

/** Matches the API `query`/`tier` param length guard. */
export const SUBSCRIPTION_TIER_FILTER_MAX_LENGTH = 64;

export const SUBSCRIPTIONS_LIST_QUERY_KEY = ["admin", "subscriptions", "list"] as const;
export const SUBSCRIPTION_DETAIL_QUERY_KEY = ["admin", "subscriptions", "detail"] as const;

/** Page size for the subscription list. The API caps `limit` at 100. */
export const SUBSCRIPTIONS_PAGE_SIZE = 25;
/** API `query` param `@MaxLength(200)`. */
export const SUBSCRIPTION_QUERY_MAX_LENGTH = 200;
export const SUBSCRIPTIONS_SEARCH_DEBOUNCE_MS = 300;
